import { createSlice } from '@reduxjs/toolkit';

const MIN_FONT_SIZE: number = 8;
const MAX_FONT_SIZE: number = 20;

export interface AppState {
  value: {
    fontSize: number;
  };
  status: 'idle' | 'loading' | 'success' | 'failure';
  notification: {
    count: number;
  };
  cart: {
    count: number;
  };
  error: string;
}

const initialState: AppState = {
  value: {
    fontSize: 8,
  },
  status: 'idle',
  notification: {
    count: 0,
  },
  cart: {
    count: 0,
  },
  error: '',
};

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    toggleLoading: (state, action) => {
      state.status = action.payload ? 'loading' : 'idle';
    },
    increaseFontSize: (state) => {
      if (state.value.fontSize < MAX_FONT_SIZE) {
        state.value.fontSize += 4;
      }
    },
    decreaseFontSize: (state) => {
      if (state.value.fontSize > MIN_FONT_SIZE) {
        state.value.fontSize -= 4;
      }
    },
    notificationCount: (state, action) => {
      state.notification.count = action.payload;
    },
    cartCount: (state, action) => {
      state.cart.count = action.payload;
    },
  },
});

export const {
  toggleLoading,
  increaseFontSize,
  decreaseFontSize,
  notificationCount,
  cartCount,
} = appSlice.actions;

export default appSlice.reducer;
